import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import { Helmet } from "react-helmet"

import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
import AdminsTable from './Components/AdminsTable';
import Alert from '../../Components/Alert';
import { bindActionCreators } from 'redux';
import { getAdmins } from '../../store/user/actions';
import { timers } from '../../config';

class Admins extends Component {
  state = {
    adminDeleted: false,
    adminCreated: false,
    adminUpdated: false,
    email: ''
  }
  componentDidMount() {
    const state = this.props.location.state || {};

    if (state.adminCreated || state.adminUpdated) {
      this.setState(state, () => {
        setTimeout(() => {
          this.setState({adminCreated: false, adminUpdated: false, email: ''})
        }, timers.alertHide)
      });
      window.history.replaceState({}, undefined, '/admins');
    }

    if (this.props.user.admins.length < 1 || state.adminCreated || state.adminUpdated) {
      this.props.getAdmins();
    }
  }

  onAdminDeleted = (adminEmail) => {
    this.props.getAdmins();
    this.setState({adminDeleted: true, email: adminEmail}, () => {
      setTimeout(() => {
        this.setState({adminDeleted: false, email: ''});
      }, timers.alertHide);
    })
  }

  render() {

    let msg = undefined;

    // admin was created
    if (this.state.adminCreated || this.state.adminUpdated) {
      msg = `Admin ${this.state.email} is ${this.state.adminCreated? 'created': 'updated'} successfully`;
    } else
    // admin deleted
    if (this.state.adminDeleted) {
      msg = `Admin ${this.state.email} is deleted successfully`;
    }

    return (
      <div className="wrapper">
        <Helmet>
          <title>Admins | Go Bus Dashboard</title>
        </Helmet>
        <Sidebar/>
        <div className="main-panel">
          <div className="page-title">
            <div className="page-title-heading">
              <h1>Dashboard Admins</h1>
              <Btn className="btn simple"><NavLink to="/new-admin">add admin</NavLink></Btn>
            </div>
          </div>
          <Alert color="green" msg={msg} />

          <AdminsTable onDeleteFailed={this.onDeleteFailed} onAdminDeleted={this.onAdminDeleted} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
})

const mapDispatchToProps = dispatch => ({
  getAdmins: bindActionCreators(getAdmins, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Admins));